export enum CreditCard {
  A_A_R_P_ESSENTIAL_REWARDS_MASTERCARD_FROM_BARCLAYS = "A_A_R_P_ESSENTIAL_REWARDS_MASTERCARD_FROM_BARCLAYS",
  A_A_R_P_TRAVEL_REWARDS_MASTERCARD_FROM_BARCLAYS = "A_A_R_P_TRAVEL_REWARDS_MASTERCARD_FROM_BARCLAYS",
  AAA_DAILY_ADVANTAGE_VISA_SIGNATURE = "AAA_DAILY_ADVANTAGE_VISA_SIGNATURE",
  AAA_TRAVEL_ADVANTAGE_VISA_SIGNATURE = "AAA_TRAVEL_ADVANTAGE_VISA_SIGNATURE",
  AADVANTAGEAVIATORRED_WORLD_ELITE_MASTERCARD = "AADVANTAGEAVIATORRED_WORLD_ELITE_MASTERCARD",
  ACTIVE_CASH_CARD = "ACTIVE_CASH_CARD",
  AER_LINGUS_VISA_SIGNATURE_CREDIT_CARD = "AER_LINGUS_VISA_SIGNATURE_CREDIT_CARD",
  AEROPLAN_CARD = "AEROPLAN_CARD",
  AIR_FRANCE_KLM_WORLD_ELITE_MASTERCARD = "AIR_FRANCE_KLM_WORLD_ELITE_MASTERCARD",
  ALASKA_AIRLINES_BUSINESS_CREDIT_CARD = "ALASKA_AIRLINES_BUSINESS_CREDIT_CARD",
  ALASKA_AIRLINES_VISA_SIGNATURE = "ALASKA_AIRLINES_VISA_SIGNATURE",
  ALLWAYS_REWARDS_VISA = "ALLWAYS_REWARDS_VISA",
  AMAZON_BUSINESS_CARD = "AMAZON_BUSINESS_CARD",
  AMAZON_BUSINESS_PRIME_CARD = "AMAZON_BUSINESS_PRIME_CARD",
  AMAZON_VISA = "AMAZON_VISA",
  AMERICAN_AIRLINES_AADVANTAGE_MILEUP_CARD = "AMERICAN_AIRLINES_AADVANTAGE_MILEUP_CARD",
  AMERICAN_AIRLINES_AADVANTAGE_PLATINUM_SELECT_WORLD_ELITE_MASTERCARD = "AMERICAN_AIRLINES_AADVANTAGE_PLATINUM_SELECT_WORLD_ELITE_MASTERCARD",
  AMERICAN_EXPRESS_BLUE_CASH_PREFERRED_CARD = "AMERICAN_EXPRESS_BLUE_CASH_PREFERRED_CARD",
  AMERICAN_EXPRESS_GOLD_CARD = "AMERICAN_EXPRESS_GOLD_CARD",
  AMERICAN_EXPRESS_GREEN_CARD = "AMERICAN_EXPRESS_GREEN_CARD",
  AMERICAN_EXPRESS_THE_PLATINUM_CARD = "AMERICAN_EXPRESS_THE_PLATINUM_CARD",
  AMEX_EVERYDAY_CREDIT_CARD_AMERICAN_EXPRESS_CARD = "AMEX_EVERYDAY_CREDIT_CARD_AMERICAN_EXPRESS_CARD",
  APPLE_CARD = "APPLE_CARD",
  ASHLEY_ADVANTAGE_CREDIT_CARD = "ASHLEY_ADVANTAGE_CREDIT_CARD",
  ATHLETA_REWARDS_MASTERCARD = "ATHLETA_REWARDS_MASTERCARD",
  ATT_POINTS_PLUS_CARD_FROM_CITI = "ATT_POINTS_PLUS_CARD_FROM_CITI",
  ATTUNE_CARD = "ATTUNE_CARD",
  AUTOGRAPH_CARD = "AUTOGRAPH_CARD",
  AUTOGRAPH_JOURNEY_CARD = "AUTOGRAPH_JOURNEY_CARD",
  BANANA_REPUBLIC_REWARDS_MASTERCARD = "BANANA_REPUBLIC_REWARDS_MASTERCARD",
  BANK_OF_AMERICA_ATMOS_REWARDS_ASCENT_VISA_SIGNATURE_CARD = "BANK_OF_AMERICA_ATMOS_REWARDS_ASCENT_VISA_SIGNATURE_CARD",
  BANK_OF_AMERICA_ATMOS_REWARDS_SUMMIT_VISA_INFINITE_CREDIT_CARD = "BANK_OF_AMERICA_ATMOS_REWARDS_SUMMIT_VISA_INFINITE_CREDIT_CARD",
  BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS = "BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS",
  BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_FOR_STUDENTS = "BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_FOR_STUDENTS",
  BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_SECURED = "BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_SECURED",
  BANK_OF_AMERICA_PREMIUM_REWARDS = "BANK_OF_AMERICA_PREMIUM_REWARDS",
  BANK_OF_AMERICA_PREMIUM_REWARDS_ELITE = "BANK_OF_AMERICA_PREMIUM_REWARDS_ELITE",
  BANK_OF_AMERICA_TRAVEL_REWARDS = "BANK_OF_AMERICA_TRAVEL_REWARDS",
  BANK_OF_AMERICA_TRAVEL_REWARDS_FOR_STUDENTS = "BANK_OF_AMERICA_TRAVEL_REWARDS_FOR_STUDENTS",
  BANK_OF_AMERICA_TRAVEL_REWARDS_SECURED = "BANK_OF_AMERICA_TRAVEL_REWARDS_SECURED",
  BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS = "BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS",
  BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_FOR_STUDENTS = "BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_FOR_STUDENTS",
  BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_SECURED = "BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_SECURED",
  BANKAMERICARD = "BANKAMERICARD",
  BANKAMERICARD_FOR_STUDENTS = "BANKAMERICARD_FOR_STUDENTS",
  BANKAMERICARD_SECURED = "BANKAMERICARD_SECURED",
  BARCLAYS_CARNIVAL_WORLD_MASTERCARD = "BARCLAYS_CARNIVAL_WORLD_MASTERCARD",
  BARCLAYS_G_M_BUSINESS_MASTERCARD = "BARCLAYS_G_M_BUSINESS_MASTERCARD",
  BARCLAYS_G_M_REWARDS_MASTERCARD = "BARCLAYS_G_M_REWARDS_MASTERCARD",
  BARCLAYS_JET_BLUE_PREMIER_CARD = "BARCLAYS_JET_BLUE_PREMIER_CARD",
  BARNES_NOBLE_MASTERCARD = "BARNES_NOBLE_MASTERCARD",
  BASS_PRO_SHOPS_AND_CABELAS_CLUB_BUSINESS_MASTERCARD = "BASS_PRO_SHOPS_AND_CABELAS_CLUB_BUSINESS_MASTERCARD",
  BASS_PRO_SHOPS_CLUB_CARD = "BASS_PRO_SHOPS_CLUB_CARD",
  BEST_FRIENDS_CREDIT_CARD = "BEST_FRIENDS_CREDIT_CARD",
  BILT_BLUE_CARD = "BILT_BLUE_CARD",
  BILT_MASTERCARD = "BILT_MASTERCARD",
  BILT_OBSIDIAN_CARD = "BILT_OBSIDIAN_CARD",
  BILT_PALLADIUM_CARD = "BILT_PALLADIUM_CARD",
  BJS_ONE_MASTERCARD = "BJS_ONE_MASTERCARD",
  BLUE_BUSINESS_CASHTM_CARD = "BLUE_BUSINESS_CASHTM_CARD",
  BLUE_BUSINESS_PLUS_CREDIT_CARD = "BLUE_BUSINESS_PLUS_CREDIT_CARD",
  BLUE_CASH_EVERYDAY_CARD_FROM_AMERICAN_EXPRESS_CARD = "BLUE_CASH_EVERYDAY_CARD_FROM_AMERICAN_EXPRESS_CARD",
  BMO_CASH_BACK_MASTERCARD = "BMO_CASH_BACK_MASTERCARD",
  BREAD_REWARDS_AMERICAN_EXPRESS_CARD = "BREAD_REWARDS_AMERICAN_EXPRESS_CARD",
  BREEZE_EASYVISA_CREDIT_CARD = "BREEZE_EASYVISA_CREDIT_CARD",
  BRITISH_AIRWAYS_VISA_SIGNATURE_CREDIT_CARD = "BRITISH_AIRWAYS_VISA_SIGNATURE_CREDIT_CARD",
  BUSINESS_ADVANTAGE_CUSTOMIZED_CASH_REWARDS_CREDIT_CARD = "BUSINESS_ADVANTAGE_CUSTOMIZED_CASH_REWARDS_CREDIT_CARD",
  BUSINESS_ADVANTAGE_TRAVEL_REWARDS_CREDIT_CARD = "BUSINESS_ADVANTAGE_TRAVEL_REWARDS_CREDIT_CARD",
  BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_CREDIT_CARD = "BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_CREDIT_CARD",
  BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_MASTERCARD_SECURED_CREDIT_CARD = "BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_MASTERCARD_SECURED_CREDIT_CARD",
  BUSINESS_GOLD_CARD = "BUSINESS_GOLD_CARD",
  BUSINESS_GREEN_REWARDS_CARD = "BUSINESS_GREEN_REWARDS_CARD",
  BUSINESS_PLATINUM_CARD = "BUSINESS_PLATINUM_CARD",
  CABELAS_CLUB_CARD = "CABELAS_CLUB_CARD",
  CAPITAL_ONE_B_JS_ONE_MASTERCARD = "CAPITAL_ONE_B_JS_ONE_MASTERCARD",
  CAPITAL_ONE_SAVOR_ONE_REWARDS = "CAPITAL_ONE_SAVOR_ONE_REWARDS",
  CAPITAL_ONE_WALMART_REWARDS_MASTERCARD = "CAPITAL_ONE_WALMART_REWARDS_MASTERCARD",
  CAPITAL_VACATIONSWORLD_MASTERCARD = "CAPITAL_VACATIONSWORLD_MASTERCARD",
  CELEBRITY_CRUISES_VISA_SIGNATURE = "CELEBRITY_CRUISES_VISA_SIGNATURE",
  CHASE_FREEDOM_FLEX_CREDIT_CARD = "CHASE_FREEDOM_FLEX_CREDIT_CARD",
  CHASE_FREEDOM_RISE_CREDIT_CARD = "CHASE_FREEDOM_RISE_CREDIT_CARD",
  CHASE_FREEDOM_UNLIMITED_CREDIT_CARD = "CHASE_FREEDOM_UNLIMITED_CREDIT_CARD",
  CHASE_INSTACART_MASTERCARD = "CHASE_INSTACART_MASTERCARD",
  CHASE_SAPPHIRE_PREFERRED_CREDIT_CARD = "CHASE_SAPPHIRE_PREFERRED_CREDIT_CARD",
  CHASE_SAPPHIRE_RESERVE_CREDIT_CARD = "CHASE_SAPPHIRE_RESERVE_CREDIT_CARD",
  CHASE_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD = "CHASE_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD",
  CHASE_SOUTHWEST_RAPID_REWARDS_PRIORITY_CREDIT_CARD = "CHASE_SOUTHWEST_RAPID_REWARDS_PRIORITY_CREDIT_CARD",
  CHASE_THE_NEW_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD = "CHASE_THE_NEW_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD",
  CHASE_UNITED_BUSINESS_CARD = "CHASE_UNITED_BUSINESS_CARD",
  CHASE_UNITED_CLUB_BUSINESS_CARD = "CHASE_UNITED_CLUB_BUSINESS_CARD",
  CHASE_UNITED_CLUB_INFINITE_CARD = "CHASE_UNITED_CLUB_INFINITE_CARD",
  CHASE_UNITED_EXPLORER_CARD = "CHASE_UNITED_EXPLORER_CARD",
  CHASE_UNITED_GATEWAY_CREDIT_CARD = "CHASE_UNITED_GATEWAY_CREDIT_CARD",
  CHASE_UNITED_QUEST_CARD = "CHASE_UNITED_QUEST_CARD",
  CHOICE_PRIVILEGES_MASTERCARD = "CHOICE_PRIVILEGES_MASTERCARD",
  CHOICE_PRIVILEGES_SELECT_MASTERCARD = "CHOICE_PRIVILEGES_SELECT_MASTERCARD",
  CITI_AADVANTAGE_BUSINESS_WORLD_ELITE_MASTERCARD = "CITI_AADVANTAGE_BUSINESS_WORLD_ELITE_MASTERCARD",
  CITI_AADVANTAGE_EXECUTIVE_WORLD_ELITE_MASTERCARD = "CITI_AADVANTAGE_EXECUTIVE_WORLD_ELITE_MASTERCARD",
  CITI_BLOOMINGDALES_CREDIT_CARDS = "CITI_BLOOMINGDALES_CREDIT_CARDS",
  CITI_CUSTOM_CASH_CARD = "CITI_CUSTOM_CASH_CARD",
  CITI_DIAMOND_PREFERRED_CREDIT_CARD = "CITI_DIAMOND_PREFERRED_CREDIT_CARD",
  CITI_DILLARDS_CREDIT_CARDS = "CITI_DILLARDS_CREDIT_CARDS",
  CITI_DOUBLE_CASH_CARD = "CITI_DOUBLE_CASH_CARD",
  CITI_EXXON_MOBIL_SMART_CARD_CREDIT_CARD = "CITI_EXXON_MOBIL_SMART_CARD_CREDIT_CARD",
  CITI_MACYS_CREDIT_CARDS = "CITI_MACYS_CREDIT_CARDS",
  CITI_PRO_XTRA_CREDIT_CARD = "CITI_PRO_XTRA_CREDIT_CARD",
  CITI_REWARDS_CREDIT_CARD = "CITI_REWARDS_CREDIT_CARD",
  CITI_REWARDS_STUDENT_CREDIT_CARD = "CITI_REWARDS_STUDENT_CREDIT_CARD",
  CITI_SECURED_MASTERCARD = "CITI_SECURED_MASTERCARD",
  CITI_SHELL_FUEL_REWARDS_MASTERCARD = "CITI_SHELL_FUEL_REWARDS_MASTERCARD",
  CITI_SIMPLICITY_CREDIT_CARD = "CITI_SIMPLICITY_CREDIT_CARD",
  CITI_STRATA_CARD = "CITI_STRATA_CARD",
  CITI_STRATA_ELITE_CARD = "CITI_STRATA_ELITE_CARD",
  CITI_STRATA_PREMIER_CARD = "CITI_STRATA_PREMIER_CARD",
  CITI_WAYFAIR_CREDIT_CARDS = "CITI_WAYFAIR_CREDIT_CARDS",
  COSTCO_ANYWHERE_VISA_BUSINESS_CARD_BY_CITI = "COSTCO_ANYWHERE_VISA_BUSINESS_CARD_BY_CITI",
  COSTCO_ANYWHERE_VISA_CARD_BY_CITI = "COSTCO_ANYWHERE_VISA_CARD_BY_CITI",
  CREDIT_ONE_BANK_AMERICAN_EXPRESS_CARD = "CREDIT_ONE_BANK_AMERICAN_EXPRESS_CARD",
  CREDIT_ONE_BANK_WANDER_AMERICAN_EXPRESS_CARD = "CREDIT_ONE_BANK_WANDER_AMERICAN_EXPRESS_CARD",
  DELTA_SKYMILES_BLUE_AMERICAN_EXPRESS_CARD = "DELTA_SKYMILES_BLUE_AMERICAN_EXPRESS_CARD",
  DELTA_SKYMILES_GOLD_AMERICAN_EXPRESS_CARD = "DELTA_SKYMILES_GOLD_AMERICAN_EXPRESS_CARD",
  DELTA_SKYMILES_GOLD_BUSINESS_CARD = "DELTA_SKYMILES_GOLD_BUSINESS_CARD",
  DELTA_SKYMILES_PLATINUM_AMERICAN_EXPRESS_CARD = "DELTA_SKYMILES_PLATINUM_AMERICAN_EXPRESS_CARD",
  DELTA_SKYMILES_PLATINUM_BUSINESS_CARD = "DELTA_SKYMILES_PLATINUM_BUSINESS_CARD",
  DELTA_SKYMILES_RESERVE_AMERICAN_EXPRESS_CARD = "DELTA_SKYMILES_RESERVE_AMERICAN_EXPRESS_CARD",
  DELTA_SKYMILES_RESERVE_BUSINESS_CARD = "DELTA_SKYMILES_RESERVE_BUSINESS_CARD",
  DISCOVER_IT_CASH_BACK_CREDIT_CARD = "DISCOVER_IT_CASH_BACK_CREDIT_CARD",
  DISCOVER_IT_CHROME_GAS_RESTAURANT_CREDIT_CARD = "DISCOVER_IT_CHROME_GAS_RESTAURANT_CREDIT_CARD",
  DISCOVER_IT_MILES_CREDIT_CARD = "DISCOVER_IT_MILES_CREDIT_CARD",
  DISCOVER_IT_SECURED_CREDIT_CARD = "DISCOVER_IT_SECURED_CREDIT_CARD",
  DISCOVER_IT_STUDENT_CASH_BACK_CREDIT_CARD = "DISCOVER_IT_STUDENT_CASH_BACK_CREDIT_CARD",
  DISCOVER_IT_STUDENT_CHROME_CREDIT_CARD = "DISCOVER_IT_STUDENT_CHROME_CREDIT_CARD",
  DISNEY_PREMIER_VISA_CARD = "DISNEY_PREMIER_VISA_CARD",
  DISNEY_VISA_CARD = "DISNEY_VISA_CARD",
  DOORDASH_REWARDS_MASTERCARD = "DOORDASH_REWARDS_MASTERCARD",
  DUCKS_UNLIMITED_REWARDS_VISA = "DUCKS_UNLIMITED_REWARDS_VISA",
  ELAN_EVERYDAY_REWARDS_PLUS = "ELAN_EVERYDAY_REWARDS_PLUS",
  ELAN_MAX_CASH_PREFERRED_VISA = "ELAN_MAX_CASH_PREFERRED_VISA",
  EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARD = "EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARD",
  EMIRATES_SKYWARDS_REWARDS_WORLD_ELITE_MASTERCARD = "EMIRATES_SKYWARDS_REWARDS_WORLD_ELITE_MASTERCARD",
  EVERGREENBY_FNBO_CREDIT_CARD = "EVERGREENBY_FNBO_CREDIT_CARD",
  F_N_B_O_GREEN_SELECT_CREDIT_CARD = "F_N_B_O_GREEN_SELECT_CREDIT_CARD",
  FREE_SPIRIT_TRAVEL_MORE_WORLD_ELITE_MASTERCARD = "FREE_SPIRIT_TRAVEL_MORE_WORLD_ELITE_MASTERCARD",
  FRONTIER_AIRLINES_WORLD_MASTERCARD = "FRONTIER_AIRLINES_WORLD_MASTERCARD",
  GAP_GOOD_REWARDS_MASTERCARD = "GAP_GOOD_REWARDS_MASTERCARD",
  GETAWAY_BY_FNBOCREDIT_CARD = "GETAWAY_BY_FNBOCREDIT_CARD",
  GOLDMAN_SACHS_MY_GM_REWARDS_MASTERCARD = "GOLDMAN_SACHS_MY_GM_REWARDS_MASTERCARD",
  GREENSTATE_CU_WORLD_MASTERCARD = "GREENSTATE_CU_WORLD_MASTERCARD",
  HARRIS_TEETER_REWARDS_WORLD_ELITE_MASTERCARD = "HARRIS_TEETER_REWARDS_WORLD_ELITE_MASTERCARD",
  HAWAIIAN_AIRLINES_WORLD_ELITE_BUSINESS_MASTERCARD = "HAWAIIAN_AIRLINES_WORLD_ELITE_BUSINESS_MASTERCARD",
  HAWAIIAN_AIRLINES_WORLD_ELITE_MASTERCARD = "HAWAIIAN_AIRLINES_WORLD_ELITE_MASTERCARD",
  HILTON_HONORS_AMERICAN_EXPRESS_ASPIRE_CARD = "HILTON_HONORS_AMERICAN_EXPRESS_ASPIRE_CARD",
  HILTON_HONORS_AMERICAN_EXPRESS_CARD = "HILTON_HONORS_AMERICAN_EXPRESS_CARD",
  HILTON_HONORS_AMERICAN_EXPRESS_SURPASS_CARD = "HILTON_HONORS_AMERICAN_EXPRESS_SURPASS_CARD",
  HILTON_HONORS_BUSINESS_CARD = "HILTON_HONORS_BUSINESS_CARD",
  HSBC_ELITE_CREDIT_CARD = "HSBC_ELITE_CREDIT_CARD",
  HSBC_PREMIER_CREDIT_CARD = "HSBC_PREMIER_CREDIT_CARD",
  HUNTINGTON_VOICE_BUSINESS_MASTERCARD = "HUNTINGTON_VOICE_BUSINESS_MASTERCARD",
  IBERIA_VISA_SIGNATURE_CREDIT_CARD = "IBERIA_VISA_SIGNATURE_CREDIT_CARD",
  IHG_ONE_REWARDS_PREMIER_BUSINESS_CREDIT_CARD = "IHG_ONE_REWARDS_PREMIER_BUSINESS_CREDIT_CARD",
  IHG_ONE_REWARDS_PREMIER_CREDIT_CARD = "IHG_ONE_REWARDS_PREMIER_CREDIT_CARD",
  IHG_ONE_REWARDS_TRAVELER_CREDIT_CARD = "IHG_ONE_REWARDS_TRAVELER_CREDIT_CARD",
  INK_BUSINESS_CASH_CREDIT_CARD = "INK_BUSINESS_CASH_CREDIT_CARD",
  INK_BUSINESS_PREFERRED_CREDIT_CARD = "INK_BUSINESS_PREFERRED_CREDIT_CARD",
  INK_BUSINESS_PREMIER_CREDIT_CARD = "INK_BUSINESS_PREMIER_CREDIT_CARD",
  INK_BUSINESS_UNLIMITED_CREDIT_CARD = "INK_BUSINESS_UNLIMITED_CREDIT_CARD",
  JCPENNEY_CREDIT_CARD = "JCPENNEY_CREDIT_CARD",
  JETBLUE_BUSINESS_CARD = "JETBLUE_BUSINESS_CARD",
  JETBLUE_CARD = "JETBLUE_CARD",
  JETBLUE_PLUS_CARD = "JETBLUE_PLUS_CARD",
  KOHLS_REWARDS_VISA = "KOHLS_REWARDS_VISA",
  KROGER_REWARDS_WORLD_ELITE_MASTERCARD = "KROGER_REWARDS_WORLD_ELITE_MASTERCARD",
  LL_BEAN_MASTERCARD = "LL_BEAN_MASTERCARD",
  MARRIOTT_BONVOY_BEVY_AMERICAN_EXPRESS_CARD = "MARRIOTT_BONVOY_BEVY_AMERICAN_EXPRESS_CARD",
  MARRIOTT_BONVOY_BOLD_CREDIT_CARD = "MARRIOTT_BONVOY_BOLD_CREDIT_CARD",
  MARRIOTT_BONVOY_BOUNDLESS_CREDIT_CARD = "MARRIOTT_BONVOY_BOUNDLESS_CREDIT_CARD",
  MARRIOTT_BONVOY_BOUNTIFUL_CARD_AMERICAN_EXPRESS_CARD = "MARRIOTT_BONVOY_BOUNTIFUL_CARD_AMERICAN_EXPRESS_CARD",
  MARRIOTT_BONVOY_BOUNTIFUL_CREDIT_CARD = "MARRIOTT_BONVOY_BOUNTIFUL_CREDIT_CARD",
  MARRIOTT_BONVOY_BRILLIANT_AMERICAN_EXPRESS_CARD = "MARRIOTT_BONVOY_BRILLIANT_AMERICAN_EXPRESS_CARD",
  MARRIOTT_BONVOY_BUSINESS_CARD = "MARRIOTT_BONVOY_BUSINESS_CARD",
  MILES_MOREWORLD_ELITE_MASTERCARD = "MILES_MOREWORLD_ELITE_MASTERCARD",
  MY_BEST_BUY_CREDIT_CARDS = "MY_BEST_BUY_CREDIT_CARDS",
  MYLOWES_REWARDS_CREDIT_CARD = "MYLOWES_REWARDS_CREDIT_CARD",
  NASCAR_AMERICAN_EXPRESS_CARD = "NASCAR_AMERICAN_EXPRESS_CARD",
  NAVY_FEDERAL_FLAGSHIP_VISA_SIGNATURE = "NAVY_FEDERAL_FLAGSHIP_VISA_SIGNATURE",
  NAVYIST_REWARDS_MASTERCARD = "NAVYIST_REWARDS_MASTERCARD",
  NHL_DISCOVER_IT_CREDIT_CARD = "NHL_DISCOVER_IT_CREDIT_CARD",
  NORWEGIAN_CRUISE_LINE_WORLD_MASTERCARD = "NORWEGIAN_CRUISE_LINE_WORLD_MASTERCARD",
  ONE_KEY_CARD = "ONE_KEY_CARD",
  PAYPAL_CREDIT = "PAYPAL_CREDIT",
  PENFED_PATHFINDER_REWARDS_VISA_SIGNATURE = "PENFED_PATHFINDER_REWARDS_VISA_SIGNATURE",
  PLATINUM_MASTERCARD = "PLATINUM_MASTERCARD",
  PLATINUM_PLUS_MASTERCARD_BUSINESS_CARD = "PLATINUM_PLUS_MASTERCARD_BUSINESS_CARD",
  PLATINUM_REWARDS_VISA_WITH_NO_ANNUAL_FEE = "PLATINUM_REWARDS_VISA_WITH_NO_ANNUAL_FEE",
  PLATINUM_SECURED = "PLATINUM_SECURED",
  PLATINUM_VISA = "PLATINUM_VISA",
  PLATINUM_VISA_FOR_REBUILDING_CREDIT = "PLATINUM_VISA_FOR_REBUILDING_CREDIT",
  PLATINUM_X5_VISA = "PLATINUM_X5_VISA",
  PLUM_CARD = "PLUM_CARD",
  PNC_CASH_REWARDS_VISA = "PNC_CASH_REWARDS_VISA",
  POTTERY_BARN_KEY_REWARDS_VISA = "POTTERY_BARN_KEY_REWARDS_VISA",
  PRIME_VISA = "PRIME_VISA",
  QUICKSILVER_REWARDS = "QUICKSILVER_REWARDS",
  QUICKSILVER_REWARDS_FOR_GOOD_CREDIT = "QUICKSILVER_REWARDS_FOR_GOOD_CREDIT",
  QUICKSILVER_REWARDS_FOR_STUDENTS = "QUICKSILVER_REWARDS_FOR_STUDENTS",
  QUICKSILVER_SECURED_REWARDS = "QUICKSILVER_SECURED_REWARDS",
  QUICKSILVERONE_REWARDS = "QUICKSILVERONE_REWARDS",
  RALPHS_REWARDS_WORLD_ELITE_MASTERCARD = "RALPHS_REWARDS_WORLD_ELITE_MASTERCARD",
  RCIELITE_REWARDSWORLD_MASTERCARD = "RCIELITE_REWARDSWORLD_MASTERCARD",
  REAL_REWARDS_CREDIT_CARD = "REAL_REWARDS_CREDIT_CARD",
  REDSTONE_FCU_VISA_SIGNATURE = "REDSTONE_FCU_VISA_SIGNATURE",
  REFLECT_CARD = "REFLECT_CARD",
  REI_COOP_MASTERCARD = "REI_COOP_MASTERCARD",
  ROBINHOOD_CARD = "ROBINHOOD_CARD",
  ROBINHOOD_PLATINUM_CARD = "ROBINHOOD_PLATINUM_CARD",
  ROOMS_TO_GO_CREDIT_CARD = "ROOMS_TO_GO_CREDIT_CARD",
  ROYAL_CARIBBEAN_VISA_SIGNATURE = "ROYAL_CARIBBEAN_VISA_SIGNATURE",
  SAMS_CLUB_CREDIT_CARD = "SAMS_CLUB_CREDIT_CARD",
  SAVOR_REWARDS = "SAVOR_REWARDS",
  SAVOR_REWARDS_FOR_GOOD_CREDIT = "SAVOR_REWARDS_FOR_GOOD_CREDIT",
  SAVOR_REWARDS_FOR_STUDENTS = "SAVOR_REWARDS_FOR_STUDENTS",
  SECURED_CARD = "SECURED_CARD",
  SECURED_VISACREDIT_CARD = "SECURED_VISACREDIT_CARD",
  SHOP_YOUR_WAY_MASTERCARD = "SHOP_YOUR_WAY_MASTERCARD",
  SIGNIFY_BUSINESS_CARD = "SIGNIFY_BUSINESS_CARD",
  SLATE_EDGE_CREDIT_CARD = "SLATE_EDGE_CREDIT_CARD",
  SOUTHWEST_RAPID_REWARDS_PERFORMANCE_BUSINESS_CREDIT_CARD = "SOUTHWEST_RAPID_REWARDS_PERFORMANCE_BUSINESS_CREDIT_CARD",
  SOUTHWEST_RAPID_REWARDS_PLUS_CREDIT_CARD = "SOUTHWEST_RAPID_REWARDS_PLUS_CREDIT_CARD",
  SOUTHWEST_RAPID_REWARDS_PREMIER_BUSINESS_CREDIT_CARD = "SOUTHWEST_RAPID_REWARDS_PREMIER_BUSINESS_CREDIT_CARD",
  SOUTHWEST_RAPID_REWARDS_PREMIER_CREDIT_CARD = "SOUTHWEST_RAPID_REWARDS_PREMIER_CREDIT_CARD",
  SOUTHWEST_RAPID_REWARDS_PRIORITY_CREDIT_CARD = "SOUTHWEST_RAPID_REWARDS_PRIORITY_CREDIT_CARD",
  SPARK_15_CASH_SELECT = "SPARK_15_CASH_SELECT",
  SPARK_15X_MILES_SELECT = "SPARK_15X_MILES_SELECT",
  SPARK_2_CASH = "SPARK_2_CASH",
  SPARK_2_CASH_PLUS = "SPARK_2_CASH_PLUS",
  SPARK_2X_MILES = "SPARK_2X_MILES",
  SPARK_CLASSIC = "SPARK_CLASSIC",
  SUSAN_G_KOMEN_CUSTOMIZED_CASH_REWARDS = "SUSAN_G_KOMEN_CUSTOMIZED_CASH_REWARDS",
  SYNCHRONY_AMAZON_STORE_CARD = "SYNCHRONY_AMAZON_STORE_CARD",
  SYNCHRONY_AT_HOME_INSIDER_PERKS_CREDIT_CARD = "SYNCHRONY_AT_HOME_INSIDER_PERKS_CREDIT_CARD",
  SYNCHRONY_BELK_REWARDS_CREDIT_CARD = "SYNCHRONY_BELK_REWARDS_CREDIT_CARD",
  SYNCHRONY_CAR_CARE_CREDIT_CARD = "SYNCHRONY_CAR_CARE_CREDIT_CARD",
  SYNCHRONY_CARE_CREDIT_CREDIT_CARD = "SYNCHRONY_CARE_CREDIT_CREDIT_CARD",
  SYNCHRONY_H_O_M_E_CREDIT_CARD = "SYNCHRONY_H_O_M_E_CREDIT_CARD",
  SYNCHRONY_LUXURY_CREDIT_CARD = "SYNCHRONY_LUXURY_CREDIT_CARD",
  SYNCHRONY_MATTRESS_FIRM_CREDIT_CARD = "SYNCHRONY_MATTRESS_FIRM_CREDIT_CARD",
  SYNCHRONY_MUSIC_SOUND_CREDIT_CARD = "SYNCHRONY_MUSIC_SOUND_CREDIT_CARD",
  SYNCHRONY_MY_WALGREENS_CREDIT_CARD = "SYNCHRONY_MY_WALGREENS_CREDIT_CARD",
  SYNCHRONY_OUTDOORS_CREDIT_CARD = "SYNCHRONY_OUTDOORS_CREDIT_CARD",
  SYNCHRONY_PANDORA_CREDIT_CARD = "SYNCHRONY_PANDORA_CREDIT_CARD",
  SYNCHRONY_PAY_PAL_CASHBACK_WORLD_MASTERCARD = "SYNCHRONY_PAY_PAL_CASHBACK_WORLD_MASTERCARD",
  SYNCHRONY_PREMIER_WORLD_MASTERCARD = "SYNCHRONY_PREMIER_WORLD_MASTERCARD",
  SYNCHRONY_PROJECT_CARD = "SYNCHRONY_PROJECT_CARD",
  SYNCHRONY_Q_CARD_CREDIT_CARD = "SYNCHRONY_Q_CARD_CREDIT_CARD",
  SYNCHRONY_SEWING_MORE_CREDIT_CARD = "SYNCHRONY_SEWING_MORE_CREDIT_CARD",
  SYNCHRONY_SPORTING_GOODS_CREDIT_CARDS = "SYNCHRONY_SPORTING_GOODS_CREDIT_CARDS",
  SYNCHRONY_THE_J_CREW_CREDIT_CARD = "SYNCHRONY_THE_J_CREW_CREDIT_CARD",
  TARGET_CIRCLE_CARD = "TARGET_CIRCLE_CARD",
  TD_DOUBLE_UP_CREDIT_CARD = "TD_DOUBLE_UP_CREDIT_CARD",
  THE_HOME_DEPOT_CONSUMER_CREDIT_CARD = "THE_HOME_DEPOT_CONSUMER_CREDIT_CARD",
  THE_KEY_REWARDS_VISA = "THE_KEY_REWARDS_VISA",
  TRUIST_ENJOY_CASH_CREDIT_CARD = "TRUIST_ENJOY_CASH_CREDIT_CARD",
  TSC_CREDIT_CARDS = "TSC_CREDIT_CARDS",
  U_S_BANK_U_S_B_A_N_K_S_H_I_E_L_D_V_I_S_A_C_A_R_D = "U_S_BANK_U_S_B_A_N_K_S_H_I_E_L_D_V_I_S_A_C_A_R_D",
  UNITED_BUSINESS_CARD = "UNITED_BUSINESS_CARD",
  UNITED_CLUB_BUSINESS_CARD = "UNITED_CLUB_BUSINESS_CARD",
  UNITED_CLUB_INFINITE_CARD = "UNITED_CLUB_INFINITE_CARD",
  UNITED_EXPLORER_CARD = "UNITED_EXPLORER_CARD",
  UNITED_GATEWAY_CREDIT_CARD = "UNITED_GATEWAY_CREDIT_CARD",
  UNITED_QUEST_CARD = "UNITED_QUEST_CARD",
  UPROMISEWORLD_MASTERCARD = "UPROMISEWORLD_MASTERCARD",
  US_BANK_ALTITUDE_CONNECT_VISA_SIGNATURE_CARD = "US_BANK_ALTITUDE_CONNECT_VISA_SIGNATURE_CARD",
  US_BANK_ALTITUDE_GO_SECURED_VISA_CARD = "US_BANK_ALTITUDE_GO_SECURED_VISA_CARD",
  US_BANK_ALTITUDE_GO_VISA_SIGNATURE_CARD = "US_BANK_ALTITUDE_GO_VISA_SIGNATURE_CARD",
  US_BANK_ALTITUDE_RESERVE_VISA_INFINITE_CARD = "US_BANK_ALTITUDE_RESERVE_VISA_INFINITE_CARD",
  US_BANK_BUSINESS_TRIPLE_CASH_REWARDS_VISA = "US_BANK_BUSINESS_TRIPLE_CASH_REWARDS_VISA",
  US_BANK_CASH_SECURED_VISA_CARD = "US_BANK_CASH_SECURED_VISA_CARD",
  US_BANK_CASH_VISA_SIGNATURE_CARD = "US_BANK_CASH_VISA_SIGNATURE_CARD",
  US_BANK_SECURED_VISA_CARD = "US_BANK_SECURED_VISA_CARD",
  US_BANK_SHOPPER_CASH_REWARDS_VISA_SIGNATURE_CARD = "US_BANK_SHOPPER_CASH_REWARDS_VISA_SIGNATURE_CARD",
  US_BANK_SMARTLY_VISA_SIGNATURE_CARD = "US_BANK_SMARTLY_VISA_SIGNATURE_CARD",
  USAA_CASHBACK_REWARDS_PLUS = "USAA_CASHBACK_REWARDS_PLUS",
  VEGAS_GOLDEN_KNIGHTS_CREDIT_CARD = "VEGAS_GOLDEN_KNIGHTS_CREDIT_CARD",
  VENMO_VISA_CREDIT_CARD = "VENMO_VISA_CREDIT_CARD",
  VENTURE_REWARDS = "VENTURE_REWARDS",
  VENTURE_X_BUSINESS = "VENTURE_X_BUSINESS",
  VENTURE_X_REWARDS = "VENTURE_X_REWARDS",
  VENTUREONE_REWARDS = "VENTUREONE_REWARDS",
  VENTUREONE_REWARDS_FOR_GOOD_CREDIT = "VENTUREONE_REWARDS_FOR_GOOD_CREDIT",
  VERIZON_VISA_CARD = "VERIZON_VISA_CARD",
  WELLS_FARGO_ONE_KEY_CARD = "WELLS_FARGO_ONE_KEY_CARD",
  WEST_ELM_KEY_REWARDS_VISA = "WEST_ELM_KEY_REWARDS_VISA",
  WILLIAMS_SONOMA_KEY_REWARDS_VISA = "WILLIAMS_SONOMA_KEY_REWARDS_VISA",
  WORLD_OF_HYATT_BUSINESS_CREDIT_CARD = "WORLD_OF_HYATT_BUSINESS_CREDIT_CARD",
  WORLD_OF_HYATT_CREDIT_CARD = "WORLD_OF_HYATT_CREDIT_CARD",
  WYNDHAM_REWARDS_EARNER_BUSINESS_CARD = "WYNDHAM_REWARDS_EARNER_BUSINESS_CARD",
  WYNDHAM_REWARDS_EARNER_PLUS_CARD = "WYNDHAM_REWARDS_EARNER_PLUS_CARD",
  WYNDHAM_REWARDS_EARNERCARD = "WYNDHAM_REWARDS_EARNERCARD",
  XBOX_MASTERCARD = "XBOX_MASTERCARD",
};